import classnames from 'classnames';

import { useMultiTierCheckout } from '../../context';
import SelectPaymentMethod from '../../../SelectPaymentMethod';
import Loader from 'legacy/common/components/layout/Loader';
import FadeIn from 'legacy/common/components/transition/FadeIn';
import { StepProps, StepsId } from '../../types';

import styles from '../../../Checkout.module.scss';

const SelectCardStep = ({ goToStep }: StepProps) => {
  const {
    data: { paymentMethod, checkoutSession },
    addNewCardAndSave,
    selectCardAndSave
  } = useMultiTierCheckout();

  const onCardSelect = (selectedCardId: string) => {
    selectCardAndSave(selectedCardId, {
      onSuccess: () => {
        goToStep(StepsId.ConfirmTransactionStep);
      }
    });
  };

  const onAddCard = () => {
    addNewCardAndSave({
      onSuccess: () => {
        goToStep(StepsId.ConfirmTransactionStep);
      }
    });
  };

  return (
    <div className={styles.wrapper}>
      <div className={classnames(styles.column)}>
        <Loader isOverlay isLoading={checkoutSession.isUpdatingCheckout}>
          <FadeIn>
            <div className="px-5">
              <SelectPaymentMethod
                addCard={onAddCard}
                cards={paymentMethod.cards}
                selectedCardId={paymentMethod.selectedCard.value}
                onSelect={onCardSelect}
              />
            </div>
          </FadeIn>
        </Loader>
      </div>
    </div>
  );
};

export default SelectCardStep;
